import * as type from "../types";

const initialState = {
    dialogOpen: false,
    username: ''
}

export default (state = initialState, action) => {
    switch (action.type) {

    case type.SET_USER_DIALOG:
        return {
            ...state,
            dialogOpen: action.value
        };
    default:
        return state
    }
}
